"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BaobabRoot_1 = require("../components/BaobabRoot");
var Baobab_Components_1 = require("../registry/Baobab-Components");
function withBaobabRoot(nodeDeclaration, Logger, Sender, listenerInit) {
    return function (Component) { return function (_a) {
        var baobab = _a.baobab, logNode = _a.logNode, originalProps = __rest(_a, ["baobab", "logNode"]);
        var BaobabNode = React.useContext(Baobab_Components_1.BaobabComponents).BaobabNode;
        return (React.createElement(BaobabRoot_1.BaobabRoot, { Logger: Logger, Sender: Sender, loggerProps: baobab, onLoggerInit: listenerInit }, nodeDeclaration ?
            (React.createElement(BaobabNode, { nodeDeclaration: nodeDeclaration, logNode: logNode, childProps: originalProps }, function (props) { return React.createElement(Component, __assign({}, originalProps, props)); })) :
            (React.createElement(Component, __assign({}, originalProps)))));
    }; };
}
exports.withBaobabRoot = withBaobabRoot;
